<template>
  <div class="tariffs-calculation public-section">
    <h2>Укажите направление для расчета тарифов</h2>
    <vz-switcher
      public-style
      v-model="isFrom"
      :items="switcherItems"
      :class="switcherClass"
      class="mb-20"
    />
    <div class="tariffs-calculation-wrapper flex flex-space-between mt-30">
      <vz-loader :status-loader="loading"/>
      <tariffs-calculation-location
        v-model="dispatchLocations"
        :class="isFrom ? locationClass : ''"
        is-dispatch
      />
      <vz-icon
        name="swap-horizontal"
        size="40"
        variant="low"
        class="flex-align-self-center tariffs-calculation-swap"
        :class="locationClass"
        @click="onSwap"
      />
      <tariffs-calculation-location
        v-model="destinationLocations"
        :class="isFrom? '' : locationClass"
      />
    </div>
    <vz-button
      large
      variant="primary"
      class="tariffs-calculation-btn"
      @click="onClick"
    >
      Сформировать
    </vz-button>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { getTariffs } from '~~/api/tariffs'
import { Location } from '~~/types/types'
import { useCityStore } from '~~/stores/city'
import TariffsCalculationLocation from '~~/components/public/tariffs/tariffs-calculation-location.vue'
import VzSwitcher from '~~/components/ui-kit/vz-switcher.vue'

const props = defineProps({
  twoLocationEditable: {
    type: Boolean,
    default: false
  },
  collapse: {
    type: String as PropType<'adaptive'|'collapsed'|'full'>,
    default: 'adaptive'
  }
})

const { $showToast } = useNuxtApp()
const { currentCity } = useCityStore()
const { to } = storeToRefs(useCityStore())

const loading = ref(false)
const dispatchLocations = ref([] as Location[])
const destinationLocations = ref([] as Location[])

// функционал с vz-switcher нужен только для страницы /iframe/tariffs
const isFrom = ref(false)
const switcherItems = [
  { 
    title: 'Откуда',
    value: false
  },
  { 
    title: 'Куда',
    value: true
  }
]

const switcherClass = computed(() => {
  switch (props.collapse) {
    case 'collapsed':
      return 'flex'
    default:
      return 'display-none'
  }
})

const locationClass = computed(() => {
  switch (props.collapse) {
    case 'collapsed':
      return 'display-none'
    default:
      return ''
  }
})

// onBeforeMount(() => {
//   dispatchLocations.value = [...dispatchLocations.value, currentCity]
//   if (props.twoLocationEditable && to.value.name) {
//     destinationLocations.value = [...destinationLocations.value, to.value]
//   }
// })

watch(
    () => to.value,
    (value, oldValue) => {
      if (value.guid === oldValue?.guid) {
        return
      }
      dispatchLocations.value = [currentCity]
      if (props.twoLocationEditable && to.value.name) {
        destinationLocations.value = [to.value]
      }
    },
    { immediate: true }
)

async function onClick(): Promise<void> {
  loading.value = true
  const dispatch = dispatchLocations.value.map(i => i.guid)
  const destination = destinationLocations.value.map(i => i.guid)
  const tariffs = await getTariffs({
    from: dispatch,
    to: destination,
    orgId: (useRoute().query?.orgId || '').toString()
  })
  loading.value = false
  if (tariffs?.length) {
    $showToast({
      title: 'Загрузка',
      text: 'Данные сформированы, загрузка началась',
      variant: 'success',
    })
    downloadTariff(tariffs)
  }
}

function downloadTariff(tariffsRes: any, index = 0) {
  window.location.replace(`https://files.vozovoz.ru${tariffsRes[index]}`)

  if (index < tariffsRes.length - 1) {
    setTimeout(() => {
      index++
      downloadTariff(tariffsRes, index)
    }, 1000)
  }
}

function onSwap(): void{
  const tmp = dispatchLocations.value
  dispatchLocations.value = destinationLocations.value
  destinationLocations.value = tmp
}
</script>
